<template>
  <div class="tcla-opportunities">
    <div class="tcla-panel">
      <h3 class="tcla-panel__title">💡 فرصت‌های لینک‌سازی داخلی</h3>
      <div v-if="missingLinks.length === 0" class="tcla-empty">فرصت جدیدی یافت نشد</div>
      <div v-for="(link, idx) in missingLinks" :key="idx" class="tcla-opportunity-card">
        <div class="tcla-opportunity-card__head">
          <div class="tcla-opportunity-card__source">
            <strong>{{ link.sourceTitle }}</strong>
            <span class="tcla-arrow">←</span>
            <strong>{{ link.targetTitle }}</strong>
          </div>
          <button class="tcla-btn" @click="$emit('edit-blog', getSource(link.sourceUrl))">ویرایش منبع</button>
        </div>
        <div class="tcla-opportunity-card__reason">
          💡 {{ link.reason }}
        </div>
        <div class="tcla-opportunity-card__type">
          <span class="tcla-tag tcla-tag--blue">{{ link.type }}</span>
          <span v-if="link.similarity" class="tcla-tag tcla-tag--green">شباهت {{ link.similarity }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAOpportunities',
  props: {
    missingLinks: { type: Array, default: () => [] },
    graph: { type: Object, default: () => ({ nodes: {} }) }
  },
  methods: {
    getSource(url) {
      return this.graph.nodes[url]?.source;
    }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
}

.tcla-panel__title { font-size: 0.95rem; font-weight: 700; margin: 0 0 14px 0; }
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-opportunity-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 14px;
  background: #f9fafb;
  margin-bottom: 12px;
}

.tcla-opportunity-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.tcla-opportunity-card__source {
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tcla-arrow { color: #9ca3af; }

.tcla-opportunity-card__reason {
  font-size: 0.8rem;
  color: #6b7280;
  margin-bottom: 8px;
  line-height: 1.4;
}

.tcla-opportunity-card__type {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tcla-tag {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
}
.tcla-tag--blue { background: #dbeafe; color: #3b82f6; }
.tcla-tag--green { background: #dcfce7; color: #16a34a; }

.tcla-btn {
  padding: 6px 12px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  cursor: pointer;
}
.tcla-btn:hover { background: #e5e7eb; }
</style>
